import { render } from "./activity.vue?vue&type=template&id=6cdec789&ts=true"
import script from "./activity.vue?vue&type=script&lang=ts"
export * from "./activity.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__